export const DEFAULT_LEX_FORMAT: LexFormat = 'KALDI'
export const INVALID_DURATION = -1
export const FOOTER_HEIGHT = 40
export const possibleLexFormats: LexFormat[] = ['KALDI', 'SAMPA', 'UASR']
export const DEFAULT_DIARIZATION = 0
export const DEFAULT_VAD = true
